import { Routes, Route, Navigate } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import MainLayout from '../../../layouts/MainLayout';
import { Loader, Center } from '@/components/ui';

// Eager load dashboard for instant access
import AnnouncementsDashboard from './dashboard';

// Lazy load other pages for better performance
const AnnouncementListPage = lazy(() => import('./list'));
const AnnouncementDetailPage = lazy(() => import('./view/[id]'));
const AdminPage = lazy(() => import('./admin'));
const AdminLookupsPage = lazy(() => import('./admin/lookups'));
const LookupCategoryPage = lazy(() => import('./admin/lookups/[category]'));
const NewAnnouncementPage = lazy(() => import('./new'));
const EditAnnouncementPage = lazy(() => import('./edit/[id]'));
const LocationsPage = lazy(() => import('./locations'));
const EventsPage = lazy(() => import('./events'));
const AnalyticsPage = lazy(() => import('./analytics'));

// Loading fallback
const LoadingFallback = () => (
  <Center h={400}>
    <Loader size="lg" />
  </Center>
);

/**
 * Announcement Management Routes
 * Routing configuration for Announcements domain with MainLayout
 */
export default function AnnouncementManagementRoutes() {
  return (
    <MainLayout domainKey="announcements">
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          {/* Dashboard - Default route */}
          <Route path="/" element={<AnnouncementsDashboard />} />

          {/* Announcement List */}
          <Route path="/list" element={<AnnouncementListPage />} />

          {/* Create / Edit Announcements */}
          <Route path="/new" element={<NewAnnouncementPage />} />
          <Route path="/edit/:id" element={<EditAnnouncementPage />} />

          {/* Announcement Detail View */}
          <Route path="/view/:id" element={<AnnouncementDetailPage />} />

          {/* Cross-announcement views */}
          <Route path="/locations" element={<LocationsPage />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/analytics" element={<AnalyticsPage />} />

          {/* Admin Routes */}
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/admin/lookups" element={<AdminLookupsPage />} />
          <Route path="/admin/lookups/:category" element={<LookupCategoryPage />} />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/app/announcements" replace />} />
        </Routes>
      </Suspense>
    </MainLayout>
  );
}
